/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const DevelopmentPlanStatusDto = {
    Draft: 'DRAFT',
    ReadyForRealization: 'READY_FOR_REALIZATION',
    SupervisorApproved: 'SUPERVISOR_APPROVED',
    SupervisorRejected: 'SUPERVISOR_REJECTED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Archived: 'ARCHIVED'
} as const;

export type DevelopmentPlanStatusDto = typeof DevelopmentPlanStatusDto[keyof typeof DevelopmentPlanStatusDto];



